import { UnidadeGestoraService } from './../../../../../../services/unidade-gestora.service';
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import Swal from 'sweetalert2';
import { IUnidadeGestoraModel } from "./../../../../../../models/unidade-gestora.model";
import { ISubtipoAuditoriaModel } from './../../../../../../models/subtipo-auditoria.model';
import { SubtipoAuditoriaService } from '../../../../../../services/subtipo-auditoria.service';
import { BaseFormComponent } from '../../../../../../shared/components/base-form/base-form.component';
import { IOsaExecucaoUgSubTipoModel } from '../../../../../../models/osa-execucao-model';
import { OsaExecucaoService } from '../../../../../../services/osa-execucao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-modal-incluir-ug-sub-tipo',
  templateUrl: './modal-incluir-ug-sub-tipo.component.html',
  styleUrls: ['./modal-incluir-ug-sub-tipo.component.scss']
})

export class ModalIncluirUgSubTipoComponent extends BaseFormComponent implements OnInit {

  public unidadesGestoras: IUnidadeGestoraModel[] = [] as IUnidadeGestoraModel[];
  public subtipoList: ISubtipoAuditoriaModel[] = [] as ISubtipoAuditoriaModel[];

  statusError: string = '';
  model: IOsaExecucaoUgSubTipoModel = {} as IOsaExecucaoUgSubTipoModel;
  osaExecucaoId: number;

  public form = new FormGroup({
    unidadeGestoraId: new FormControl("", Validators.required),
    subTipoAuditoriaId: new FormControl("", Validators.required)
  });

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    public matDialog: MatDialog,
    private dialogRef: MatDialogRef<ModalIncluirUgSubTipoComponent>,
    private unidadeGestoraService: UnidadeGestoraService,
    private subTipoAuditoriaService: SubtipoAuditoriaService,
    private osaExecucaoService: OsaExecucaoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(route, toastr, router, localeService, matDialog);
    this.osaExecucaoId = data.osaExecucaoId;
  }

  ngOnInit(): void {
    this.obterUnidadesGestoras();
    this.obterSubTipoAuditoria();
  }

  public salvar() {

    this.submit = true;
    if (this.form.invalid)
      return;

    const dados = {
      osaExecucaoId: this.osaExecucaoId,
      unidadeGestoraId: this.form.get("unidadeGestoraId")?.value,
      unidadeGestora: {id: this.form.get("unidadeGestoraId")?.value},
      subTipoAuditoriaId: this.form.get("subTipoAuditoriaId")?.value,
      subtipoAuditoria: {id: this.form.get("subTipoAuditoriaId")?.value},
      statusUg: 'Consultada' // fixo
    } as IOsaExecucaoUgSubTipoModel;

    this.osaExecucaoService
      .inserirUgSubTipo(dados)
      .then((res) => {
        if (res.sucesso) {
          this.exibirMensagemSucesso(res.mensagem.descricao);
          this.dialogRef.close(true);
        } else {
          this.exibirMensagemErro(res.mensagem.descricao);
        }
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem.descricao);
      });
  }

  public async obterUnidadesGestoras() {
    try {
      if (this.unidadesGestoras?.length === 0) {
        const result = await this.unidadeGestoraService.obterAtivos();
        if (result.sucesso) {
          this.unidadesGestoras = result.dados;
        }
      }
    } catch (error) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: ' Erro, ao obter unidades gestoras!',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  public async obterSubTipoAuditoria() {
    try {
      if (this.subtipoList?.length === 0) {
        const result = await this.subTipoAuditoriaService.obterAtivos();
        if (result.sucesso) {
          this.subtipoList = result.dados;
        }
      }
    } catch (error) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: ' Erro, ao obter sub tipos de auditorias!',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }


  public cancelar() {
    this.dialogRef.close();
  }

}
